import React from "react";
import { Input, Select, DatePicker, TimePicker, AutoComplete } from "antd";
import "./styles.css";

const Option = { Select };

function InputBaseField({ id, placeholder, name, value, type, IsDisabled, onClick, onChange, onBlur, onFocus, MaxLength, MinLength, Suffix, max, min, ...props }) {

    const onChangeEvent = (event) => {
        onChange(event);
    };
    return (
        <Input
            id={id}
            name={name}
            value={value}
            type={type}
            disabled={IsDisabled}
            placeholder={placeholder}
            onChange={onChangeEvent}
            className="custom-input"
            autoComplete={"off"}
            onBlur={onBlur}
            onFocus={onFocus}
            maxLength={MaxLength}
            minxLength={MinLength}
            suffix={Suffix}
            max={max}
            min={min}
        />
    )
}
function DatePickerField({ id, name, value, defaultvalue, pickertype, IsDisabled, size, onClick, onChange, onOK, onBlur, onFocus, ...props }) {

    const onChangeEvent = (date, dateString) => {
        onChange(name, dateString);
    };
    return (
        <DatePicker
            id={id}
            name={name}
            value={value}
            picker={pickertype}
            format='YYYY-MM-DD'
            disabled={IsDisabled}
            defaultValue={defaultvalue}
            onChange={onChangeEvent}
            className="custom-input"
            {...props} />
    )
}
function TimePickerField({ id, name, value, defaultvalue, IsDisabled, size, onClick, onChange, ...props }) {

    const onChangeEvent = (time, timeString) => {

        onChange(name, timeString);
    };
    return (
        <TimePicker
            id={id}
            name={name}
            value={value}
            format="HH:mm:ss"
            disabled={IsDisabled}
            defaultValue={defaultvalue}
            onChange={onChangeEvent}
            className="custom-input"
            {...props} />
    )
}
function SelectField({ id, name, value, options, onChange, IsDisabled, isClearAble, placeholder, defaultvalue, ...props }) {
    const onChangeEvent = (value) => {
        onChange(name, value);
    };

    return (
        <>
            <Select
                defaultValue={defaultvalue}
                id={id}
                name={name}
               // allowClear={isClearAble}
                onChange={onChangeEvent}
                placeholder={placeholder}
                value={value || undefined}
                className="custom-select-input"
                disabled={IsDisabled}>


                {options.map((item) => {
                    return (
                        <Option value={item.value}>{item.label}</Option>
                    )
                }
                )}
            </Select>
        </>
    );
}
function AutoCompleteField({ id, name, value, options, handleChange, IsDisabled, isClearAble, placeholder, defaultvalue, ...props }) {
    const handleSearch = (value) => {
        handleChange(name, value);
    };
    return (
        <>
            <AutoComplete
                defaultValue={defaultvalue}
                onSearch={handleSearch}
                placeholder={placeholder}
                name={name}
                onChange={handleSearch}
                //allowClear={isClearAble ? false : true}
                value={value}
                className="custom-select-input"
                disabled={IsDisabled}
                options={options}
                filterOption={true}
            >
                {options.map((option) => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </AutoComplete>
        </>
    );
}
export { InputBaseField, SelectField, DatePickerField, TimePickerField, AutoCompleteField };